import { RootState } from 'store';

// This is a simple selector that retrieves the eArkisto slice from the state
export const EArkistoSelector = (state: RootState) => state.eArkisto;

export default EArkistoSelector;
